import { http } from 'vue'

export default {
  // load company_client_reviews from the API server
  loadCompanyClientReviews (context, params = {}) {
    const withParam = ((params.with) ? '&with=' + params.with : '')
    const pageParam = '&page=' + ((params.page) ? params.page : 1)
    const perPageParam = '&per_page=' + ((params.perPage) ? params.perPage : 50)
    const typeParam = ((params.type) ? '&type=' + params.type : '')
    const periodParam = ((params.period) ? '&period=' + params.period : '')
    const statusParam = ((params.status) ? '&status=' + params.status : '')
    const clientIdParam = ((params.clientId) ? '&client_id=' + params.clientId : '')
    return http.get('company_client_reviews?company_id=' + params.companyId + clientIdParam + pageParam + perPageParam + typeParam + periodParam + statusParam + withParam)
  },
  // create company_client_review at the API server
  postCompanyClientReview (context, params = {}) {
    return http.post('company_client_reviews', params.data)
  },
  loadPriceReviwes (context) {
    return http.get('reviews_price')
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/company_client_reviews/actions.js